import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSupabaseTypedClient } from 'hooks/reactQuery';
import { useToastWrapper } from 'hooks/useToastWrapper';

import { TanstackQueryName } from 'types/frontend';

export const useToggleCVShare = (cvId: string | undefined) => {
  const supabase = useSupabaseTypedClient();
  const queryClient = useQueryClient();
  const { toastSuccess, toastError } = useToastWrapper();

  const mutation = useMutation({
    mutationFn: async (isShared: boolean) => {
      if (!cvId) return;

      const { error } = await supabase
        .from('user_cv')
        .update({ is_shared: isShared, updated_at: new Date().toISOString() })
        .eq('id', cvId);

      if (error) throw error;

      return isShared;
    },
    onSuccess: (isShared) => {
      queryClient.invalidateQueries({ queryKey: [TanstackQueryName.GetCV, cvId] });
      toastSuccess(isShared ? 'CV is now publicly shared' : 'CV sharing disabled');
    },
    onError: () => {
      toastError('Could not update sharing settings');
    },
  });

  return {
    toggleShare: (isShared: boolean) => mutation.mutate(isShared),
    isToggling: mutation.isPending,
  };
};
